import { render, staticRenderFns } from "./PlusBoldIcon.vue?vue&type=template&id=561cda16&"
import script from "./PlusBoldIcon.vue?vue&type=script&lang=ts&"
export * from "./PlusBoldIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports